import * as yup from "yup";

export const classYup = yup.object().shape({
  className: yup
    .string()
    .required("Sınıf adı gereklidir")
    .min(3, "Sınıf adı en az 3 karakter olmalıdır") // "2/A" zaten 3 karakterdir
    .max(10, "Sınıf adı en fazla 10 karakter olabilir")
    .matches(
      /^[234]\/[a-zA-ZçığöşüİĞÖŞÜ]$/,
      "Sınıf adı '2/A', '3/B' veya '4/C' formatında olmalıdır",
    ),

  teacherId: yup.string().required("Öğretmen seçimi gereklidir"),
  classType: yup.string().required("Lütfen bir sınıf tipi seçin"),
  maxStudents: yup
    .number()
    .required("Maksimum öğrenci sayısı gereklidir")
    .min(1, "En az 1 öğrenci olmalıdır")
    .max(50, "En fazla 50 öğrenci olabilir")
    .integer("Tam sayı olmalıdır"),
  description: yup.string().max(500, "Açıklama en fazla 500 karakter olabilir"),

  // YENİ: Seçilen öğrenciler array validasyonu
  selectedStudents: yup
    .array()
    .of(yup.string().required("Geçerli öğrenci ID'si gereklidir"))
    .max(
      yup.ref("maxStudents"),
      "Seçilen öğrenci sayısı maksimum limitini aşamaz",
    )
    .test(
      "unique-students",
      "Aynı öğrenci birden fazla kez seçilemez",
      function (value) {
        if (!value) return true;
        return value.length === new Set(value).size;
      },
    ),
});
